var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sb-fullscreen-template',{staticClass:"distribution-modal-container",on:{"close":_vm.editWroClosed}},[_c('inventory-transfers-root')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }